export default (value, decimals) => {
  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: decimals || 0,
  })
  return formatter.format(Number(value))
}
